import * as React from "react"
import { useNavigate } from "react-router-dom"
import PropTypes from "prop-types"
import "./StudyBadge.scss"

const StudyBadge = ({ label, studyId, disabled, dataDogActionName = "" }) => {
  const navigate = useNavigate()

  return (
    <span
      onClick={disabled ? null : () => navigate(`/study/${studyId}/overview`)}
      className={`study-badge${disabled ? " disabled" : ""}`}
      data-dd-action-name={dataDogActionName}
    >
      {label}
    </span>
  )
}

StudyBadge.propTypes = {
  label: PropTypes.string.isRequired,
  studyId: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  dataDogActionName: PropTypes.string,
}

export default StudyBadge
